'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext, useRef, useState, useEffect } from 'react';
import { ButtonElement, AccordionSectionWrapper, AccordionSectionContent, RotatingIcon, AccordionDivider, AccordionSectionContentWrapper, AccordionFade } from './elements';
import { Header } from './Header';
import { Icon } from '../Icon';
import { useCurrentAccordionIndex } from './hooks/useCurrentAccordionIndex';
import AccordionContext from './AccordionContext';
import { StateLayer } from '../../core-components';
import { attachSubComponents, separateChildrenByType } from '../../util';
export const AccordionSection = attachSubComponents('AccordionSection', /*#__PURE__*/React.forwardRef(({
  buttonClassName = '',
  iconWrapperClassName = '',
  ariaLabel = '',
  iconSrc,
  children,
  header,
  subheader,
  startOpen = false,
  transitionDuration = '.3s',
  transitionTimingFunction = 'ease-in',
  onClick,
  onOpenStateChange,
  isOpen,
  ...rest
}, fRef) => {
  const {
    numbered,
    variant
  } = useContext(AccordionContext);
  const accordionRef = useRef(null);
  const accordionIndex = useCurrentAccordionIndex(accordionRef);
  const [accordionOpen, setAccordionOpenState] = useState(isOpen ?? startOpen);
  useEffect(() => {
    setAccordionOpenState(isOpen ?? startOpen);
  }, [isOpen]);
  const [headerElements, content] = separateChildrenByType(children, Header);
  const sectionHeader = React.Children.count(headerElements) !== 0 ? headerElements : /*#__PURE__*/React.createElement(Header, null, numbered ? /*#__PURE__*/React.createElement(Header.Leading, null, /*#__PURE__*/React.createElement(Header.Number, null, accordionIndex, ".")) : iconSrc && /*#__PURE__*/React.createElement(Header.Leading, {
    className: iconWrapperClassName
  }, /*#__PURE__*/React.createElement(Icon.Compat, {
    src: iconSrc
  })), /*#__PURE__*/React.createElement(Header.Heading, null, header), subheader && /*#__PURE__*/React.createElement(Header.SupportiveText, null, subheader));
  return /*#__PURE__*/React.createElement(AccordionSectionWrapper, {
    $variant: variant,
    $isOpen: accordionOpen,
    "data-aui": "accordion.section",
    ref: accordionRef
  }, /*#__PURE__*/React.createElement(ButtonElement, _extends({
    ref: fRef,
    className: buttonClassName,
    "aria-label": ariaLabel,
    "aria-expanded": accordionOpen,
    onClick: e => {
      onClick === null || onClick === void 0 || onClick(e);
      onOpenStateChange === null || onOpenStateChange === void 0 || onOpenStateChange(!accordionOpen);
      setAccordionOpenState(!accordionOpen);
    }
  }, rest), /*#__PURE__*/React.createElement(StateLayer, null), sectionHeader, /*#__PURE__*/React.createElement(RotatingIcon, {
    src: "chevron-down",
    size: "large",
    $rotateIcon: accordionOpen
  })), /*#__PURE__*/React.createElement(AccordionSectionContentWrapper, {
    $isOpen: accordionOpen,
    $transitionDuration: transitionDuration,
    $transitionTimingFunction: transitionTimingFunction
  }, /*#__PURE__*/React.createElement(AccordionSectionContent, {
    "aria-hidden": !accordionOpen,
    $isOpen: accordionOpen,
    $hasLeader: !!iconSrc || numbered,
    $transitionDuration: transitionDuration
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      zIndex: -1,
      paddingBottom: 'var(--aui-spacing-150)'
    }
  }, content)), /*#__PURE__*/React.createElement(AccordionFade, {
    $isOpen: accordionOpen,
    $transitionDuration: transitionDuration,
    $transitionTimingFunction: transitionTimingFunction
  })), /*#__PURE__*/React.createElement(AccordionDivider, null));
}), {
  Header
});